import React, { useCallback, useMemo, useState } from 'react';
import { Lightbox } from './Lightbox';
export const useLightbox = (labels, isRightToLeft, context) => {
    const [isVisible, setIsVisible] = useState(false);
    const [currentIndex, setCurrentIndex] = useState(null);
    const openLightbox = useCallback((itemIndex) => {
        setCurrentIndex(itemIndex === -1 ? 0 : itemIndex);
        setIsVisible(true);
    }, []);
    const closeLightbox = useCallback(() => {
        setIsVisible(false);
    }, []);
    const LightboxInstance = useMemo(() => {
        function getLightboxInstance() {
            if (currentIndex === null) {
                return null;
            }
            return isVisible ? (React.createElement(Lightbox, { labels: labels, initialIndex: currentIndex, closeLightbox: closeLightbox, isRightToLeft: isRightToLeft, context: context })) : null;
        }
        return getLightboxInstance;
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [closeLightbox, currentIndex, isVisible]);
    return {
        Lightbox: LightboxInstance,
        openLightbox,
        closeLightbox,
        isLightboxActive: isVisible,
    };
};
